import { ArrowDown } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Kicker, Reveal } from "@/components/Reveal";
import { ChittaGraphic } from "@/components/ChittaGraphic";

export const Introduction = () => {
    const { t } = useSite();
    return (
        <section id="introduction" data-testid="introduction-section" className="theme-fade relative overflow-hidden mesh-light">
            <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-12 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-12 lg:gap-8 lg:px-12 lg:py-40">
                <div className="lg:col-span-7">
                    <Reveal>
                        <Kicker>{t.intro.kicker}</Kicker>
                        <h2 className="headline-section mt-6 max-w-[14ch] font-display font-semibold text-theme-ink" data-testid="intro-heading">
                            {t.intro.heading}
                        </h2>
                    </Reveal>
                </div>
                <div className="flex flex-col justify-end lg:col-span-5">
                    <Reveal delay={0.15}>
                        <p className="max-w-[54ch] text-lg leading-[1.85] text-theme-muted sm:text-xl" data-testid="intro-body">
                            {t.intro.bodyStart}
                            <strong className="font-bold text-theme-ink" data-testid="intro-body-emphasis">
                                {t.intro.bodyEmphasis}
                            </strong>{" "}
                            {t.intro.bodyMiddle}
                            <strong className="font-bold text-theme-ink" data-testid="intro-body-closing">
                                {t.intro.bodyClosing}
                            </strong>
                        </p>
                        <button
                            type="button"
                            data-testid="intro-explore-research"
                            onClick={() => document.getElementById("research")?.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" })}
                            className="group mt-10 inline-flex min-h-[44px] items-center gap-3 font-display text-sm font-semibold lowercase tracking-[0.08em] text-sky-ink"
                        >
                            <span className="border-b border-current pb-1">{t.intro.cta}</span>
                            <ArrowDown size={16} className="transition-transform duration-300 group-hover:translate-y-1" />
                        </button>
                    </Reveal>
                </div>
            </div>
            <ChittaGraphic className="pointer-events-none absolute bottom-0 left-0 w-40 opacity-70 sm:w-56" />
        </section>
    );
};
